const APPLE_PAY_INCREASE = 100;
export const formatApplePayPrice = (amount?: number | null): number =>
  parseInt(`${(amount || 0) * APPLE_PAY_INCREASE}`, 10);
